import classNames from 'classnames';
import React from 'react';
import sidebarClose from '../assets/icons/sidebarClose.svg';
import { type PresentationFrame } from '../controllers/PresentationController';
import styles from './presentations.module.css';
import { svgToIcon } from '../utils/svg';
import FrameThumbnail from './FrameThumbnail';

interface FramesProps {
  frames: PresentationFrame[];
  currentFrameIndex: number;
  navigate: (frameId: string) => void;
  close: () => void;
}
const Frames = ({
  frames,
  currentFrameIndex,
  navigate,
  close,
}: FramesProps) => {
  return (
    <div className={styles.whiteboardFrames}>
      <div className={styles.whiteboardFramesHeader}>
        <div className={styles.counter}>
          <span>{currentFrameIndex + 1}</span> / {frames.length}
        </div>

        <a onClick={close} className={styles.closeFrames}>
          {svgToIcon(sidebarClose)}
        </a>
      </div>
      <div
        className={classNames(
          'presentation-sidepanel-scroll-component',
          styles.whiteboardFramesContainer
        )}
      >
        {frames.map((frame, index) => (
          <a
            key={frame.id}
            className={classNames(styles.whiteboardFrame, {
              [styles.whiteboardFrameActive]: index === currentFrameIndex,
            })}
            onClick={() => {
              navigate(frame.id);
            }}
          >
            <FrameThumbnail frame={frame} />

            <div className={styles.whiteboardFrameText}>
              <span>{frame.getName()}</span>
              <span className={styles.number}>{index + 1}</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Frames;
